import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

import { TextField } from "../../../components";
import Logo from "../../../assets/sprintexx.png";
import { colors } from "../../css components/Style";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();

  return (
    <Grid container spacing={6}>
      <Grid size={12} textAlign={"center"}>
        <img style={{ height: "50px" }} src={Logo} alt="logo" />
        <Typography color={colors.sprintexBlue}>
          Forgot your password? No Problem, enter your email and we will send
          you the reset password link!
        </Typography>
      </Grid>

      <Grid size={12}>
        <TextField
          required
          label="Registered email"
          name="email"
          formikProps={formikProps}
          placeholder="Registered email"
        />
      </Grid>

      <Grid size={12}>
        <PrimaryLoadingButton
          fullWidth
          type="submit"
          variant="contained"
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Reset
        </PrimaryLoadingButton>
      </Grid>

      <Grid size={12} alignSelf="center" textAlign={"center"}>
        <Typography className="font" variant="caption1">
          Go back to?{" "}
          <Typography
            variant="button"
            style={{
              cursor: "pointer",
              fontWeight: 500,
              color: colors.sprintexBlue,
            }}
            onClick={() => navigate("/sign-in")}
          >
            Sign In!
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
}
